import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_IS_STARTER = defineFcm('growth_is_starter').asBoolean().withDefault(false).toConfig();
